import {html} from 'lit';
import {directive, Directive} from 'lit/directive.js';
import Base from '../base.js';
import styles from './icon.css' assert {type: 'css'};

class NamespacedDirective extends Directive {
    update(part, props) {
        part.element.setAttributeNS(props[0], part.name, props[1]);
        return props[1];
    }
}

const xlinkNamespace = 'http://www.w3.org/1999/xlink';

const namespacedDirective = directive(NamespacedDirective);

/**
 * @element inv-icon
 *
 * @class Icon
 * @classdesc This is a web component that creates an icon.
 *
 * @property {string} name - The name of the icon.
 * @property {string} width - The width of the icon.
 * @property {string} height - The height of the icon.
 * @property {string} view-box - The viewBox of the icon.
 * @property {string|null} src - The location of the icon sprite sheet.
 * @property {string} color - The color of the icon.
 */

export default class Icon extends Base {
    static get properties() {
        return {
            name: {
                type: String,
            },
            width: {
                type: String,
            },
            height: {
                type: String,
            },
            viewBox: {
                type: String,
                attribute: 'view-box',
            },
            src: {
                type: String,
            },
            color: {
                type: String,
            },
        };
    }

    constructor() {
        super();
        this.name = 'icon-arrow-up';
        this.width = '24';
        this.height = '24';
        this.viewBox = '0 0 24 24';
        this.src = null;
        this.color = 'black';
    }

    getStyleSheets() {
        return [...super.getStyleSheets(), styles];
    }

    connectedCallback() {
        super.connectedCallback();
        if (this.src === null) {
            const currentFileUrl = new URL(import.meta.url);
            const currentFolderPath = currentFileUrl.pathname.substring(
                0,
                currentFileUrl.pathname.lastIndexOf('/') + 1
            );
            this.src = `${currentFolderPath}../../assets/images/icons.svg`;
        }
    }

    render() {
        return html`
            <svg
                role="img"
                color="${this.color}"
                viewBox="${this.viewBox}"
                width="${this.width}"
                height="${this.height}"
            >
                <use id="inv-icon" href="${namespacedDirective(xlinkNamespace, `${this.src}#${this.name}`)}" />
            </svg>
        `;
    }
}

Icon.register();
